import React from 'react'
import { array, object, string } from 'prop-types'

import classNames from 'classnames/bind'

function SettingButtons (props) {
  const { style, options, using } = props
  const cx = classNames.bind(style)
  return (
    <div className={style.sets}>
      {options.map((option, index) => (
        <div
          key={index}
          className={cx({ setting: true, using: using === option.key })}
          style={option.style}
          onClick={option.onClick}
        >
          {option.name}
        </div>
      ))}
    </div>
  )
}
SettingButtons.propTypes = {
  options: array.isRequired,
  using: string,
  style: object.isRequired,
}

export default SettingButtons



// WEBPACK FOOTER //
// ./src/components/RangeEditor/SettingButtons/View.jsx